import { render, staticRenderFns } from "./NameHistory.vue?vue&type=template&id=33f085d1&"
import script from "./NameHistory.vue?vue&type=script&lang=js&"
export * from "./NameHistory.vue?vue&type=script&lang=js&"
import style0 from "./NameHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports